(function () {
    angular
      .module('kareo.ui.shared.directives.user.k-user-list-empty',[])
      .component('kUserListEmpty', {
        template: require('./k-user-list-empty.pug')()
      });
  })();
  